import React from "react";
import { Group, Stack, Text, Loader } from "@mantine/core";
import { Dropzone } from "@mantine/dropzone";
import { IconFileTypePdf } from "@tabler/icons-react";

export interface PdfDropzoneProps {
  onFileSelected: (file: File) => void;
  loading?: boolean;
  maxSize?: number;
  height?: number;
  label?: string;
  description?: string;
  disabled?: boolean;
  accept?: string[];
}

export function PdfDropzone({
  onFileSelected,
  loading = false,
  maxSize = 100 * 1024 * 1024, // 50MB default
  height = 200,
  label = "Drop your PDF here or click to select",
  description,
  disabled = false,
  accept = ["application/pdf"],
}: PdfDropzoneProps) {
  const handleDrop = (files: File[]) => {
    const file = files[0];
    if (file && file.type === "application/pdf") {
      onFileSelected(file);
    }
  };

  return (
    <Dropzone
      onDrop={handleDrop}
      accept={accept}
      multiple={false}
      loading={loading}
      disabled={disabled}
      maxSize={maxSize}
      styles={{
        root: {
          border: "none",
          padding: 0,
          background: "transparent",
        },
        inner: {
          padding: 0,
        },
      }}
    >
      <div
        className="premium-dropzone"
        style={{
          minHeight: height,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "1rem",
        }}
      >
        {loading ? (
          <Stack gap="md" align="center">
            <Loader size="lg" />
            <Text size="lg" fw={500}>
              Processing PDF...
            </Text>
          </Stack>
        ) : (
          <Stack gap="md" align="center">
            <IconFileTypePdf
              style={{
                width: 52,
                height: 52,
                color: "var(--mantine-color-blue-6)",
              }}
            />
            <div style={{ textAlign: "center" }}>
              <Text size="lg" fw={600} mb={description ? "xs" : 0}>
                {label}
              </Text>
              {description && (
                <Text size="sm" c="dimmed" style={{ maxWidth: 500 }}>
                  {description}
                </Text>
              )}
            </div>
          </Stack>
        )}
      </div>
    </Dropzone>
  );
}
